export enum LoadingAction {
  EDIT_AMOUNT = 'edit_amount',
  EDIT_LIABILITY = 'edit_liability',
  MARK_AS_PAID = 'mark_as_paid',
  MARK_AS_NOT_PAID = 'mark_as_not_paid',
  PHONE_VERIFICATION = 'phone_verification',
  DELETE = 'delete',
  MAKE_DRAFT_PRIMARY = 'make_draft_primary',
  CANCEL_AUTO_PAYMENT = 'cancel_auto_payment',
  CHANGE_CUSTOMER_BILLER_TAG = 'change_customer_biller_tag',
  REMIND_ABOUT_DELEGATED_PAYMENT = 'remind_about_delegated_payment',
  SUB_ACCOUNT_FOLD_CHANGE = 'sub_account_fold_change',
  SCHEDULE_CUSTOMER_FOR_DELETION = 'schedule_customer_for_deletion'
}
